import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="text-center">
        <div className="text-7xl md:text-8xl font-extrabold text-[#3780E0]">404</div>
        <h1 className="mt-3 text-2xl md:text-3xl font-bold text-[#0F2A4A]">Page not found</h1>
        <p className="mt-2 text-slate-600">The page you are looking for does not exist or has been moved.</p>
        <Link to="/" className="hc-btn-primary mt-6"><Home className="w-4 h-4" /> Back to Home</Link>
      </div>
    </div>
  );
}
